import React, { useState, memo } from 'react';
import { PlayIcon, PauseIcon, SkipForwardIcon, SkipBackIcon, VolumeIcon, ListMusicIcon, HeadphonesIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function MusicPanel({
  location,
  isExpanded = true,
  onToggleExpand
}) {
  const [selectedSongIndex, setSelectedSongIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  if (!location) {
    return null;
  }
  const songs = location.randomSongs || [];
  const currentSong = songs[selectedSongIndex] || {};
  const handleNextSong = () => {
    setSelectedSongIndex(prevIndex => prevIndex === songs.length - 1 ? 0 : prevIndex + 1);
  };
  const handlePrevSong = () => {
    setSelectedSongIndex(prevIndex => prevIndex === 0 ? songs.length - 1 : prevIndex - 1);
  };
  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };
  return <div className={`absolute top-0 left-0 h-full bg-black/80 backdrop-blur-sm transition-all duration-300 ease-in-out shadow-xl overflow-auto
        ${isExpanded ? 'translate-x-0' : 'translate-x-[calc(-100%+40px)]'}
        w-full md:w-1/2 lg:w-[30%] max-w-md z-30`} style={{
    pointerEvents: 'auto'
  }} onClick={e => e.stopPropagation()} data-id="element-52">
      {/* Toggle button */}
      <button onClick={e => {
      e.stopPropagation();
      onToggleExpand();
    }} className="absolute top-1/2 -right-0 transform -translate-y-1/2 bg-black/80 hover:bg-black/90 text-white p-2 rounded-r-md" aria-label={isExpanded ? 'Collapse panel' : 'Expand panel'} data-id="element-53">
        {isExpanded ? <ChevronLeftIcon size={20} data-id="element-54" /> : <ChevronRightIcon size={20} data-id="element-55" />}
      </button>
      <div className="w-full h-full flex flex-col p-6" onClick={e => e.stopPropagation()} data-id="element-56">
        <div className="mb-5" data-id="element-57">
          <h2 className="text-2xl font-bold text-white" data-id="element-58">{location.location}</h2>
          <p className="text-[#b3b3b3] text-sm mt-1" data-id="element-59">
            Your musical memories from this place
          </p>
        </div>
        <div className="flex flex-col gap-8" data-id="element-60">
          {/* Current playing song */}
          <div className="flex-grow flex flex-col items-center" data-id="element-61">
            <div className="w-48 h-48 mb-6 relative group shadow-xl rounded-md overflow-hidden" data-id="element-62">
              <img src={currentSong.albumCover} alt={`${currentSong.album} cover`} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-63" />
              <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-64">
                <button className="bg-[#1DB954] rounded-full p-3 transform transition-transform duration-200 hover:scale-110" onClick={e => {
                e.stopPropagation();
                togglePlayPause();
              }} data-id="element-65">
                  {isPlaying ? <PauseIcon className="h-8 w-8 text-black" data-id="element-66" /> : <PlayIcon className="h-8 w-8 text-black" data-id="element-67" />}
                </button>
              </div>
            </div>
            <div className="text-center w-full mb-6" data-id="element-68">
              <h3 className="text-xl font-bold mb-2 text-white" data-id="element-69">
                {currentSong.title}
              </h3>
              <p className="text-[#b3b3b3] text-base mb-1" data-id="element-70">
                {currentSong.artist}
              </p>
              <p className="text-[#b3b3b3] text-sm" data-id="element-71">{currentSong.album}</p>
            </div>
            <div className="w-full max-w-xs" data-id="element-72">
              <div className="w-full bg-[#535353] rounded-full h-1.5 mb-4" data-id="element-73">
                <div className="bg-[#1DB954] h-1.5 rounded-full w-2/5" data-id="element-74"></div>
              </div>
              <div className="flex items-center justify-between text-xs text-[#b3b3b3]" data-id="element-75">
                <span data-id="element-76">1:24</span>
                <span data-id="element-77">3:45</span>
              </div>
            </div>
          </div>
          {/* Song list */}
          <div className="mt-4" data-id="element-78">
            <div className="mb-4 flex items-center" data-id="element-79">
              <ListMusicIcon className="mr-2 text-[#1DB954]" size={18} data-id="element-80" />
              <h3 className="text-lg font-semibold text-white" data-id="element-81">
                Your Playlist
              </h3>
            </div>
            <div className="overflow-y-auto max-h-[280px] pr-2" data-id="element-82">
              {songs.map((song, index) => <div key={song.id} className={`p-3 mb-2 rounded-md flex items-center cursor-pointer transition-colors ${index === selectedSongIndex ? 'bg-[#282828]' : 'hover:bg-[#282828]'}`} onClick={e => {
              e.stopPropagation();
              setSelectedSongIndex(index);
            }} data-id="element-83">
                  <img src={song.albumCover} alt={song.album} className="w-12 h-12 object-cover rounded-md mr-3 shadow-md" data-id="element-84" />
                  <div className="flex-grow min-w-0" data-id="element-85">
                    <p className={`font-medium truncate ${index === selectedSongIndex ? 'text-[#1DB954]' : 'text-white'}`} data-id="element-86">
                      {song.title}
                    </p>
                    <p className="text-[#b3b3b3] text-xs truncate" data-id="element-87">
                      {song.artist}
                    </p>
                  </div>
                  {index === selectedSongIndex && <div className="w-2 h-2 rounded-full bg-[#1DB954] ml-2" data-id="element-88"></div>}
                </div>)}
            </div>
          </div>
        </div>
        <div className="mt-auto pt-6" data-id="element-89">
          <div className="flex items-center justify-center space-x-6 mb-4" data-id="element-90">
            <button className="text-[#b3b3b3] hover:text-white transition-colors" onClick={e => {
            e.stopPropagation();
            handlePrevSong();
          }} data-id="element-91">
              <SkipBackIcon size={22} data-id="element-92" />
            </button>
            <button className={`${isPlaying ? 'bg-[#1DB954]' : 'bg-white'} text-black rounded-full p-3 hover:scale-105 transition-all`} onClick={e => {
            e.stopPropagation();
            togglePlayPause();
          }} data-id="element-93">
              {isPlaying ? <PauseIcon size={24} data-id="element-94" /> : <PlayIcon size={24} data-id="element-95" />}
            </button>
            <button className="text-[#b3b3b3] hover:text-white transition-colors" onClick={e => {
            e.stopPropagation();
            handleNextSong();
          }} data-id="element-96">
              <SkipForwardIcon size={22} data-id="element-97" />
            </button>
          </div>
          <div className="flex items-center space-x-3" data-id="element-98">
            <VolumeIcon size={18} className="text-[#b3b3b3]" data-id="element-99" />
            <div className="w-full bg-[#535353] rounded-full h-1.5" data-id="element-100">
              <div className="bg-white h-1.5 rounded-full w-2/3 hover:bg-[#1DB954] transition-colors" data-id="element-101"></div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}